"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RulerBase = exports.RulerModelState = void 0;
var dom_1 = require("@devexpress/utils/lib/utils/dom");
var document_renderer_1 = require("../../../canvas/renderes/common/document-renderer");
var RulerModelState = (function () {
    function RulerModelState(modelValue, enabled) {
        this.modelValue = modelValue;
        this.enabled = enabled;
    }
    RulerModelState.prototype.clone = function () {
        return new RulerModelState(this.modelValue, this.enabled);
    };
    return RulerModelState;
}());
exports.RulerModelState = RulerModelState;
var RulerBase = (function () {
    function RulerBase(modelData, controls) {
        this._visible = true;
        this.modelData = modelData;
        this.controls = controls;
        this.rootElement = document_renderer_1.DocumentRenderer.renderContainer(this.getRootClassName());
    }
    Object.defineProperty(RulerBase.prototype, "visible", {
        get: function () { return this._visible; },
        enumerable: false,
        configurable: true
    });
    RulerBase.prototype.dispose = function () {
        dom_1.DomUtils.hideNode(this.rootElement);
        this.rootElement = null;
    };
    RulerBase.prototype.setVisible = function (visible) {
        if (this._visible != visible) {
            this._visible = visible;
            this.rootElement.style.display = visible ? 'block' : 'none';
        }
    };
    return RulerBase;
}());
exports.RulerBase = RulerBase;
